import DraggableSearch from "@/infrastructure/Sidebar/SidebarFavorites/draggableSearch.component";
import { FavoriteSearch } from "@/types";
import { reorderFavorites } from "@/utils/favorites.utils";
import React from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

type SidebarFavoritesDraggableSectionProps = {
  editingSearches: FavoriteSearch[];
  setEditingSearches: React.Dispatch<React.SetStateAction<FavoriteSearch[]>>;
};

const SidebarFavoritesDraggableSection: React.FC<
  SidebarFavoritesDraggableSectionProps
> = ({ editingSearches, setEditingSearches }) => {
  function moveSearch(dragIndex: number, hoverIndex: number) {
    const updatedSearches = reorderFavorites(
      editingSearches,
      dragIndex,
      hoverIndex
    ); // Use utility function
    setEditingSearches(updatedSearches);
  }

  return (
    <div className="flex flex-col gap-0 ps-0 grow h-full overflow-y-auto">
      <DndProvider backend={HTML5Backend}>
        {editingSearches
          .sort((a, b) => a.favourite_order - b.favourite_order)
          .map((search, index) => (
            <DraggableSearch
              key={search.id}
              search={search}
              index={index}
              moveSearch={moveSearch}
            />
          ))}
      </DndProvider>
    </div>
  );
};

export default SidebarFavoritesDraggableSection;
